export { default as PaperAirplaneSolidIcon } from './PaperAirplaneSolidIcon';
